// This file is automatically generated. Do not edit it directly.
// NOTE (CBAM mobile / P0-SEC-01): native session storage + deep-link auth were wired in by hand.
// If a Lovable / `supabase gen` step ever regenerates this file, re-apply the `storage`,
// `detectSessionInUrl` and `debug` changes below. Web behaviour is unchanged (localStorage, debug on).
import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import type { Database } from './types';
import { secureStorageAdapter } from './secureStorageAdapter';

const SUPABASE_URL = "https://ewyfhrjexfrmcjhqzsmm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3eWZocmpleGZybWNqaHF6c21tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MDQ1NjIsImV4cCI6MjA3MzE4MDU2Mn0.sfY5nq_bJY7_c1qlf_DgMZXDhITWUo0c6TZLr2yzGJ8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const isNative = Capacitor.isNativePlatform();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Web: localStorage (unchanged). Native: app-sandboxed secure storage (token never in WebView localStorage).
    storage: secureStorageAdapter,
    persistSession: true,
    autoRefreshToken: true,
    // Native auth callbacks arrive via cbam:// deep link (handled in src/lib/native/deepLinks.ts),
    // not via the loaded URL, so URL session detection is web-only.
    detectSessionInUrl: !isNative,
    flowType: 'pkce',
    debug: !isNative,
  }
});